<template>
	<div>
		<label><b>{{ label }}</b></label>
		<multiselect
			v-model="selectedSellers"
			track-by="email"
			placeholder="Masukkan Nama Seller"
			:custom-label="dropshipperLabel"
			:show-labels="false"
			:allow-empty="true"
			:multiple="true"
			:options="dropshippers"
			@search-change="fetchDropshippers"
			@input="update"
		>
			<template slot="selection" slot-scope="{ values, isOpen }">
				<span
					class="multiselect__single"
					v-if="values.length"
					v-show="!isOpen"
				>
					{{ values.length }} options selected
				</span>
			</template>
		</multiselect>
	</div>
</template>

<script>
import { duplicateVar, getAxiosErrorMessage } from '@/lib/helper';
import userApi from '@/api/user';

export default {
	props: {
		label: {
			type: String,
			default: '',
		},
		selectedDropshippers: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			selectedSellers: [],
			dropshippers: [],
			dropshipperKeyword: '',
		};
	},
	methods: {
		dropshipperLabel({ name, email }) {
			return `${name} - ${email}`;
		},
		fetchDropshippers(query) {
			if (query.length >= 1) {
				this.dropshipperKeyword = query;
				this.getDropshippers();
			}
		},
		getDropshippers() {
			const params = {
				keyword: this.dropshipperKeyword,
				role: 'owner',
				owner_type: 'dropshipper', // seller
			};

			const callback = (response) => {
				let dropshippers = response.data;

				if (dropshippers.length > 0) {
					dropshippers = dropshippers.map((data) => {
						const newObj = {};
						newObj.user_id = data._id;
						newObj.name = data.name;
						newObj.email = data.email;
						return newObj;
					});
				}

				this.dropshippers = dropshippers;
			};
			const errorCallback = (e) => {
				const msg = getAxiosErrorMessage(e);
				console.log(msg);
			};
			userApi.getUsersMinimal(params, callback, errorCallback);
		},
		update() {
			this.$emit('update:selected-dropshippers', this.selectedSellers);
		},
	},
	watch: {
		selectedDropshippers() {
			this.selectedSellers = duplicateVar(this.selectedDropshippers);
		},
	},
};
</script>
